import React, { createContext, useState, useMemo } from "react";
import { AnalisisCreditoMainScreen } from "./AnalisisCreditoMainScreen";
import { Route } from "react-router-dom";
import { AnalisisCreditoDetalle } from "./AnalisisCreditoDetalle";
import { AnalisisCreditoResultadosOperacionScreen } from "./AnalisisCreditoResultadosOperacionScreen";

export const AnalisisCreditoContext = createContext(null);
export const AnalisisCreditoScreen = () => {
  const [stateAnalisis, setStateAnalisis] = useState({
    folio: "",
    cliente: "",
    filtros: {
      razonSocial: [],
      tipoSolicitud: [],
      lineaCredito: [],
      estado: [],
      sucursal: [],
      vendedor: [],
      folio: [],
    }
  });
  const contextValue = useMemo(
    () => ({
      
      state: stateAnalisis,
      setState: setStateAnalisis,
    }),
    [stateAnalisis, setStateAnalisis]
  );
  return (
    <AnalisisCreditoContext.Provider value={contextValue}>
      <Route
        path="/SolicitudCredito/Main"
        component={() => <AnalisisCreditoMainScreen />}
      />
      <Route
        path="/SolicitudCredito/ResultadosOperacion"
        component={() => <AnalisisCreditoResultadosOperacionScreen />}
      />
      <Route
        path="/SolicitudCredito/Detalle"
        component={() => <AnalisisCreditoDetalle />}
      />
    </AnalisisCreditoContext.Provider>
  );
};
